const IS_LOADING = "list/organisations_types/IS_LOADING";
const IS_ERROR = "list/organisations_types/IS_ERROR";
const LIST = "list/organisations_types/LIST";
export { IS_LOADING, IS_ERROR, LIST };
